import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Routes } from '@/routes';
import { PageContainer } from '@/components';
import MessagesList from './Messages/MessagesList';

export function MessagesListPage() {

  const navigate = useNavigate();
  const [t] = useTranslation(['common']);

  const onChooseMessage = (id: string | number) => {
    navigate(Routes.UserMessageView.replace(':id', String(id)));
  };

  return (
    <PageContainer title={t('common:labels.messages')}>
      <MessagesList onChooseMessage={onChooseMessage} />
    </PageContainer>
  );
}

export default MessagesListPage;
